import React, { useEffect } from 'react';
import './ValueEdition.css';
import { Leaf, Info } from 'lucide-react';

const herbsData = [
  {
    name: 'Ashwagandha',
    benefit: 'Reduces stress, anxiety, and boosts energy',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421637/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Ashawagdan_hewp98.jpg'
  },
  {
    name: 'Turmeric',
    benefit: 'Anti-inflammatory and antioxidant properties',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421636/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/turmoric_l6meh5.jpg'
  },
  {
    name: 'Neem',
    benefit: 'Supports skin health, immune system, and detoxification',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421860/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/neem_powder_ia9hpw.jpg'
  },
  {
    name: 'Moringa',
    benefit: 'Rich in vitamins, minerals, and antioxidants',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421860/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/moring_powder_afliqq.jpg'
  },
  {
    name: 'Tulsi (Holy Basil)',
    benefit: 'Supports respiratory health and reduces stress',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421903/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/tulasi_izcgju.jpg'
  },
  {
    name: 'Shatavari',
    benefit: 'Supports women’s health and hormonal balance',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421903/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/shatavari_jy4ika.jpg'
  },
  {
    name: 'Ginger',
    benefit: 'Helps with digestion, nausea, and inflammation',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421941/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Zingar_qdfpky.jpg'
  },
  {
    name: 'Amla (Indian Gooseberry)',
    benefit: 'Rich in Vitamin C, supports immunity and skin health',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421942/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Amla_lqfozd.jpg'
  },
  {
    name: 'Brahmi',
    benefit: 'Enhances cognitive function and reduces stress',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421986/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Brahmi_qpz4xv.jpg'
  },
  {
    name: 'Triphala',
    benefit: 'Aids in digestive health and detoxification',
    image: 'https://res.cloudinary.com/drevfgyks/image/upload/v1729421984/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/thripala_etuxs7.jpg'
  },
  {
    name: 'Annatto Seeds',
    benefit: 'Exhibits natural antimicrobial and anti-inflammatory properties.',
    image: 'https://res.cloudinary.com/dexueorjm/image/upload/v1776845844/Annatto_Seeds_bulaqb.png'
  },
  {
    name: 'Safed Musli Powder',
    benefit: 'Enhances vitality, stamina, and reproductive health.',
    image: 'https://res.cloudinary.com/dexueorjm/image/upload/v1776846520/Safed_Musli_Powder_y2jmdv.png'
  },
];

const ValueEdition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="ve-premium-page">

      {/* Hero Section */}
      <div className="ve-hero">
        <div className="ve-hero-overlay"></div>
        <div className="ve-hero-content">
          <span className="ve-hero-badge">Nature's Best</span>
          <h1 className="ve-hero-title">Value Added Products</h1>
          <p className="ve-hero-subtitle">
            Premium quality medicinal herbs, powders, and wood products processed with care
            to retain maximum potency and natural goodness.
          </p>
        </div>
      </div>

      <div className="ve-container">

        {/* Intro */}
        <div className="ve-intro">
          <h2>Natural Ingredients and Food Supplements</h2>
          <p>Explore our range of high-quality value-added products derived from our sustainable farms.</p>
        </div>

        {/* Grid */}
        <div className="ve-grid">
          {herbsData.map((herb, index) => (
            <div key={index} className="ve-card">
              <div className="ve-image-wrapper">
                <img src={herb.image} alt={herb.name} className="ve-image" />
              </div>
              <div className="ve-card-body">
                <h3 className="ve-card-title">{herb.name}</h3>
                <div className="ve-benefit-box">
                  <Leaf size={16} className="ve-icon" />
                  <p className="ve-card-text">{herb.benefit}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="ve-note-section">
          <div className="ve-note-content">
            <Info size={24} className="ve-note-icon" />
            <p>
              <strong>Note:</strong> We deal with all raw medicinal herbs, wood products, and powders,
              as well as many more custom value additions tailored to your needs.
            </p>
          </div>
        </div>

        <div className="ve-footer-tag">Emerging Farmers Empowerment</div>
      </div>
    </div>
  );
};

export default ValueEdition;
